import React from 'react';
import StudentsListFunctional from './components/students-list-functional';

const StudentsList = () => {
	return <StudentsListFunctional />;
};

export default StudentsList;
